import { Routes, Route, useLocation } from 'react-router-dom'
import { ProtectedElement } from '@praxis/component-auth'
import { ErrorBoundary } from '@praxis/component-logging'
import { ToastProvider } from '@enterprise-ui/canvas-ui-react'
import { ErrorContent } from './ErrorContent'
import { DashboardPage } from '../views/dashboard'
import { Unauthorized } from '../views/common/Unauthorized'
// import { PageNotFound } from '../views/common/PageNotFound'
import { ItemMFE } from '../views/search/'
import { BulkMfe } from '../views/bulk/'
import { AuthLogin } from '../views/common/AuthLogin'
import { Relationship } from '../views/relationship'
import { IauManageMfe } from '../views/iau/manage'
import { IauCreateMfe } from '../views/iau/create'
import { IauListMfe } from '../views/iau/list'
import { Notify } from '../views/common/Notification'
import { UploadHistoryMfe } from '../views/uploadHistory'

export const MainRouter = (props) => {
  const location = useLocation()
  const { getUserProfile, canUserBulk } = props
  return (
    <ErrorBoundary key={location.pathname} FallbackComponent={ErrorContent}>
      <ToastProvider location="top">
        <Routes>
          {getUserProfile?.roles?.length > 0 ||
          getUserProfile?.itemRoles?.length > 0 ? (
            <>
              <Route
                path="/"
                element={
                  <ProtectedElement>
                    <DashboardPage />
                  </ProtectedElement>
                }
                unauthorizedRoute={'/unauthorized'}
              />
              {['/search', '/item-search/:path'].map((path) => (
                <Route
                  key={path}
                  path={path}
                  element={
                    <ProtectedElement>
                      <ItemMFE />
                    </ProtectedElement>
                  }
                  unauthorizedRoute={'/unauthorized'}
                />
              ))}
              <Route
                path="/bulk"
                element={
                  <ProtectedElement>
                    {canUserBulk ? <BulkMfe /> : <Unauthorized />}
                  </ProtectedElement>
                }
                unauthorizedRoute={'/unauthorized'}
              />
            </>
          ) : (
            <Route path="/" element={<Unauthorized />} />
          )}
          <Route
            path="/iau"
            element={
              <ProtectedElement>
                <IauListMfe />
              </ProtectedElement>
            }
            unauthorizedRoute={'/unauthorized'}
          />
          <Route
            path="/iau/list"
            element={
              <ProtectedElement>
                <IauListMfe />
              </ProtectedElement>
            }
            unauthorizedRoute={'/unauthorized'}
          />
          <Route
            path="/iau/item-attribute-update-request"
            element={
              <ProtectedElement>
                <IauManageMfe />
              </ProtectedElement>
            }
            unauthorizedRoute={'/unauthorized'}
          />
          <Route
            path="/iau/create"
            element={
              <ProtectedElement>
                <IauCreateMfe />
              </ProtectedElement>
            }
            unauthorizedRoute={'/unauthorized'}
          />
          <Route
            path="/upload-history"
            element={
              <ProtectedElement>
                <UploadHistoryMfe />
              </ProtectedElement>
            }
            unauthorizedRoute={'/unauthorized'}
          />
          <Route path="/auth/login" element={<AuthLogin />} />
          <Route path="/unauthorized" element={<Unauthorized />} />
          <Route
            path="/relationship"
            element={
              <ProtectedElement>
                <Relationship />
              </ProtectedElement>
            }
            unauthorizedRoute={'/unauthorized'}
          />
          {/* <Route path="*" element={<PageNotFound />} /> */}
        </Routes>
        <Notify />
      </ToastProvider>
    </ErrorBoundary>
  )
}
